import { CreateButton, CreateButtonProps } from '@refinedev/antd';
import { useGo, useResourceParams } from '@refinedev/core';
import type { PointerEvent } from 'react';

import { usePermissionContext } from '@/contexts/PermissionContext';

interface ProtectedCreateButtonProps extends CreateButtonProps {
  keepQuery?: boolean;
}

const ProtectedCreateButton = ({
  keepQuery = false,
  resource: resourceNameFromProps,
  meta,
  onClick,
  ...rest
}: ProtectedCreateButtonProps) => {
  const { hasPermission } = usePermissionContext();
  const go = useGo();
  const { resource, identifier } = useResourceParams({ resource: resourceNameFromProps });
  const resolvedResource = resourceNameFromProps ?? identifier ?? resource?.name;
  const canKeepQuery = keepQuery && resolvedResource;
  const handleClick = (event: PointerEvent<HTMLButtonElement>) => {
    onClick?.(event);
    if (!canKeepQuery) {
      return;
    }

    go({
      to: { resource: resolvedResource, action: 'create', meta },
      options: { keepQuery: true },
    });
  };

  return hasPermission('create') ? (
    <CreateButton
      className="ProtectedCreateButton"
      resource={resourceNameFromProps}
      meta={meta}
      onClick={canKeepQuery ? handleClick : onClick}
      {...rest}
    />
  ) : null;
};

export default ProtectedCreateButton;
